/**
 * Transform pagination
 * @param {Object} input meta
 * @returns {Object} pagination
 */
export const transformPagination = (input = {}) => {
	return {
		pages: input.last_page,
		activePage: input.current_page,
		perPage: input.per_page,
		total: input.total,
	};
};